import React, { useState } from "react";
import { f7, Page, Button } from "framework7-react";
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';
// import logo from '../../src/img/logo/eatbids-sm-logo.png';

const PageRegister = () => {
  const [cust_fname, setName] = useState('');
  const [cust_email, setEmail] = useState('');
  const [cust_password, setPassword] = useState('');
  const [data, setData] = useState([]);
  const eatBidsLogo = require('./../images/logo/eatbids-logo.png');

  const handleRegister = (e) => {
        e.preventDefault()
        axios.post(API_BASE_URL + 'restforgotpswd', data,
        {
          headers: {
            'Authorization': 'Basic ' + API_AUTH
          }, 
        }).then(response => {
          console.log(response.data)
        if(response.data.status == 'success'){
          localStorage.setItem('id', response.data.data.rest_id);
          //localStorage.setItem('token', response.data.data.token);
          localStorage.setItem('auth', true);
          f7.views.main.router.navigate('/otpforget/');
        }
      }).catch(error => f7.toast.create({
        text: "Your email not in our database",
        position: 'top',
        cssClass: 'bg-color-red',
        closeTimeout: 2000
      }).open());
    
  };

  const imageUrl = 'https://www.eatbids.com/admin/assets/images/apps/eatbids-banner-pic.jpg'; // Replace with your image URL

  const BannerCover = {
    backgroundImage: `url(${imageUrl})`, // Set the background image URL
    backgroundRepeat: 'no-repeat', // Optional: Set background-repeat property
    backgroundSize: 'cover', // Optional: Set background-size property
    backgroundPosition: 'center', // Optional: Set background-position property
    // width: '300px', // Set the width of the container
    // height: '200px', // Set the height of the container
  };

  // const backgroundColor = 'rgba(255, 255, 0, 0.5) !important'; // Red background with 50% transparency
  const backgroundColor = 'rgba(255, 255, 255, 0.5)';
  const divTransparent = {
    background: backgroundColor, // Set the background color with transparency
  };

  const backgroundColor1 = 'rgba(255, 255, 255, 0.2)';
  const divTransparent1 = {
    background: backgroundColor1, // Set the background color with transparency
  };

  return (
    <Page noToolbar noNavbar noSwipeback loginScreen style={BannerCover}>
      <section className="section-b-space pt-0">
        <div className="container">
          <div className="row">
            <div className="col-sm p-0" style={divTransparent}> 
              {/* <img className="img-fluid login-img" src="https://themes.pixelstrap.com/zomo-app/assets/images/background/login-img.jpg" alt="login-img"/>
              <img className="img-fluid line-vector" src="https://themes.pixelstrap.com/zomo-app/assets/images/onboarding/line.png" alt="line" /> */}
            </div>
            <div className="col-sm p-0" style={divTransparent}>
              <div className="custom-logo-div">
                <div className="custom-logo">
                  <img class="img-fluid mb-3 mt-3 " src={eatBidsLogo} alt="eatBids" style={{width: "200px"}}/>
                </div>
              </div>
              <div className="custom-container" style={divTransparent1}>
                <form className="auth-form mt-5" onSubmit={handleRegister} >
                  <h2>Forget Password</h2>
                  <div className="form-group mt-4">
                    <label className="form-label fw-semibold dark-text">Enter Email Address</label>
                    <div className="d-flex gap-3">
                      <div className="form-input dark-border-gradient">
                        <input type="email" className="form-control" id="email" required validate onInput={(e) => setData({...data, rest_email : e.target.value})} placeholder="Registered Email Address" />                  
                      </div>
                    </div>
                  </div>            
                  <Button type="submit" className="btn theme-btn w-100 mt-4" large  >Send</Button>            
                </form>
                {/* <div className="division">
                  <span>OR</span>
                </div> */}
                <p className="text-center mt-3 text-3"> Back to <a href="/login/" className="text-yellow">Sign In</a></p>
                <p className="text-center">By continue, you agree to our Terms of service Privacy Policy Content Policy</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default PageRegister;